import React from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import Select from 'react-select';
import { required } from '../../../forms';

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
    {touched &&
      ((error && <span>{error}</span>) ||
        (warning && <span>{warning}</span>))}
  </InputGroup>
);

const renderNoteField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <FormGroup>
    <ControlLabel>Notes</ControlLabel>
    <FormControl
      {...input}
      componentClass="textarea"
      name="note"
      placeholder="Describe the problem."
    />
    {touched &&
      ((error && <span>{error}</span>) ||
        (warning && <span>{warning}</span>))}
  </FormGroup>
);

const RenderSelectInput = ({input, options, name, id, label}) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <Select
      id={id}
      name={name}
      options={options}
      value={input.value}
      onChange={(value) => input.onChange(value.value)}
      onBlur={(value) => input.onBlur(value.value)}
    />
  </FormGroup>
);

const issueTypes = [
  { label: 'Hotel Closed', value: 'CL' },
  { label: 'Duplicate hotel', value: 'DU' },
  { label: 'Info incorrect', value: 'IN' },
  { label: 'Not a hotel', value: 'NO' },
  { label: 'Wrong brand', value: 'BR' },
  { label: 'Other', value: 'OT' },
];

const HotelFeedbackForm = (props) => {
  const { handleSubmit, pristine, reset, submitting, event } = props;

  return (
    <div>
      <h1>Hotel Issue</h1>
      <p>
        Something wrong? Let us know so we can get fixed. This is place to report bad data on hotels.
      </p>
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Field
            name="issue_type"
            component={RenderSelectInput}
            label="Issue Type"
            options={issueTypes}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="note"
            type="textarea"
            component={renderNoteField}
            label="Note"
            validate={[required]}
          />
        </FormGroup>
        <FormGroup>
          <ButtonToolbar>
            <Button
              disabled={pristine || submitting}
              bsStyle="success"
              type="submit"
            >
              <i className="fa fa-pencil fa-lg" />
              Submit
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'hotelFeedbackForm', // a unique identifier for this form
})(HotelFeedbackForm);



// WEBPACK FOOTER //
// src/routes/feedback/components/HotelFeedbackForm.js